import React from 'react';
import { PriceAlert } from '../components/PriceAlert';
import { Hero } from '../components/Hero';
import { Testimonial } from '../components/Testimonial';
import { ProblemSolution } from '../components/ProblemSolution';
import { ValueStack } from '../components/ValueStack';
import { ModuleBreakdown } from '../components/ModuleBreakdown';
import { Guarantee } from '../components/Guarantee';
import { PricingSection } from '../components/PricingSection';
import { Footer } from '../components/Footer';
import { RecentPurchaseToast } from '../components/RecentPurchaseToast';
export function LandingPage() {
  return <div className="w-full min-h-screen bg-navy font-body text-white" data-id="element-1304">
      <PriceAlert data-id="element-1305" />
      <Hero data-id="element-1306" />
      <Testimonial data-id="element-1307" />
      <ProblemSolution data-id="element-1308" />
      <ValueStack data-id="element-1309" />
      <ModuleBreakdown data-id="element-1310" />
      <Guarantee data-id="element-1311" />
      <PricingSection data-id="element-1312" />
      <Footer data-id="element-1313" />
      <RecentPurchaseToast data-id="element-1314" />
    </div>;
}